import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { useRef } from "react";
import { cn } from "./utils.js";
export function nextTabIndex(current, count, key) {
    if (count <= 0)
        return null;
    switch (key) {
        case "ArrowRight":
        case "ArrowDown":
            return (current + 1) % count;
        case "ArrowLeft":
        case "ArrowUp":
            return (current - 1 + count) % count;
        case "Home":
            return 0;
        case "End":
            return count - 1;
        default:
            return null;
    }
}
export function Tabs({ ariaLabel, className, idPrefix, items, onChange, value, variant = "underline", }) {
    const refs = useRef([]);
    const selected = items.findIndex((item) => item.value === value);
    const tabStop = selected === -1 ? 0 : selected;
    function handleKeyDown(event, index) {
        const next = nextTabIndex(index, items.length, event.key);
        if (next === null)
            return;
        event.preventDefault();
        const item = items[next];
        if (!item)
            return;
        refs.current[next]?.focus();
        onChange(item.value);
    }
    return (_jsx("div", { "aria-label": ariaLabel, className: cn("flex max-w-full overflow-x-auto", variant === "underline"
            ? "gap-6 border-b border-stone-200"
            : "w-fit gap-1 rounded-xl border border-stone-200 bg-stone-50 p-1", className), role: "tablist", children: items.map((item, index) => {
            const active = index === selected;
            return (_jsxs("button", { "aria-controls": idPrefix ? `${idPrefix}-panel-${item.value}` : undefined, "aria-selected": active, className: cn("inline-flex min-w-11 shrink-0 items-center justify-center gap-2 px-3 text-sm font-semibold whitespace-nowrap transition-colors", variant === "underline"
                    ? cn("-mb-px h-11 border-b-2", active
                        ? "border-emerald-800 text-stone-950"
                        : "border-transparent text-stone-500 hover:text-stone-900")
                    : cn("h-9 rounded-lg max-lg:h-11", active
                        ? "bg-surface text-stone-950 shadow-md"
                        : "text-stone-500 hover:text-stone-900")), id: idPrefix ? `${idPrefix}-tab-${item.value}` : undefined, onClick: () => onChange(item.value), onKeyDown: (event) => handleKeyDown(event, index), ref: (node) => {
                    refs.current[index] = node;
                }, role: "tab", tabIndex: index === tabStop ? 0 : -1, type: "button", children: [item.icon, item.label, item.badge] }, item.value));
        }) }));
}
